import React from 'react';
interface CardProps {
  title: string;
  value: string;
  icon: ReactNode;
}
export const Card: React.FC<CardProps> = ({
  title,
  value,
  icon
}) => {
  return <div className="bg-gray-800 rounded-xl p-4 border border-gray-700 shadow-lg backdrop-blur-sm bg-opacity-60" data-id="element-994">
      <div className="flex items-start justify-between" data-id="element-995">
        <div data-id="element-996">
          <p className="text-sm text-gray-400" data-id="element-997">{title}</p>
          <p className="text-2xl font-bold mt-1" data-id="element-998">{value}</p>
        </div>
        <div className="p-2 bg-gray-700 rounded-lg" data-id="element-999">{icon}</div>
      </div>
    </div>;
};